import { createContext, ReactNode, useContext, useMemo } from 'react';
import useNotification from 'antd/es/notification/useNotification';

type OpNotificationContextValue = ReturnType<typeof useNotification>[0];

const OpNotificationContext = createContext<
  OpNotificationContextValue | undefined
>(undefined);

export const OpNotificationProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [api, context] = useNotification({
    placement: 'bottomRight',
  });

  const contextValue = useMemo(() => api, [api]);

  return (
    <OpNotificationContext.Provider value={contextValue}>
      {context}
      {children}
    </OpNotificationContext.Provider>
  );
};

/**
 * TODO: We will need to start adding wrappers around each hapi call to include
 * classNames from AlertWrapperWithoutSuir.tsx
 */
export const useOpNotification = (): OpNotificationContextValue => {
  const context = useContext(OpNotificationContext);

  if (!context) {
    throw new Error(
      'useNotification must be used within a OpNotificationProvider',
    );
  }

  return context;
};
